/**
 * Lifecycle states a match or team-tie sub-match can report via the live
 * scorecards REST API and websocket feed.
 */
export enum MatchStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  SCORED = 'SCORED',
}
